import ErrorPage from "../pages/ErrorPage/ErrorPage";
import PostshopLocatorPage from "../pages/PostshopLocatorPage";

export {
  ErrorPage,
  PostshopLocatorPage,
};


// WEBPACK FOOTER //
// ./src/routes/external.ts